<section id="refund-hero" class="w-100 text-light"
  style="margin-top: 66px; background: linear-gradient(45deg, #1A2042, #173580);">
  <div class="container py-5">
    <div class="">
      <!-- Left: About intro -->
      <div class="text-center mb-4 mb-lg-0">
        <h1 class="fw-bold mb-4">Looking for a job in the software industry?</h1>
        <p class="lead mb-4 fw-medium">
          At ChalkBasket, we prepare you with the right skills, tools, and guidance to secure a job in the software
          industry and grow into a successful tech career
        </p>
        <button class="btn btn-outline-light px-4 py-2 rounded-2 shadow-sm mt-3" (click)="navigateAndScroll('/home')">
          Sign up for free
        </button>
      </div>
    </div>
  </div>
</section>

<section class="legal-section">
  <div class="legal-content container-md mt-5 mb-5">
    <h3 class="text-center">Cancellation Policy</h3>
    <p class="effective-date text-center"><strong>Effective Date:</strong> November 6, 2025</p>
    <hr>

    <p>At <strong>ChalkBasket.com</strong>, we value your trust and are committed to providing quality training and mentorship services.
      This Refund & Cancellation Policy explains the terms under which course registrations, payments, and cancellations
      are handled.</p>

    <h4>1. Course Registration</h4>
    <ul>
      <li>Once you enroll in a course or workshop, your seat is reserved, and resources are allocated to you.</li>
      <li>Please review all course details before making a payment.</li>
    </ul>

    <h4>2. Cancellation by Student</h4>
    <ul>
      <li><strong>Before Course Start Date:</strong> If you cancel your registration at least 5 days before the course
        begins, you may be eligible for a partial refund (after deducting administrative charges).</li>
      <li><strong>After Course Start Date:</strong> Cancellations made after the course has started are not eligible for
        a refund.</li>
      <li>Requests must be sent in writing via the
        <a routerLink="/contact" (click)="scrollToTop()"
          class="link-offset-2 link-underline link-underline-opacity-0">Contact Us</a>
        section of the website.
      </li>
    </ul>

    <h4>3. Cancellation by ChalkBasket.com</h4>
    <ul>
      <li>We reserve the right to postpone, reschedule, or cancel a course due to unforeseen circumstances (such as
        trainer unavailability or technical issues).</li>
      <li>In such cases, students will be offered:
        <ul>
          <li>A transfer to the next available batch, or</li>
          <li>A full refund (if no alternative is acceptable).</li>
        </ul>
      </li>
    </ul>

    <h4>4. Refund Eligibility</h4>
    <p>Refunds are applicable only under the following conditions:</p>
    <ul>
      <li>Duplicate payment made by mistake.</li>
      <li>Course cancelled by ChalkBasket.com without rescheduling options.</li>
    </ul>

    <h4>5. Non-Refundable Items</h4>
    <ul>
      <li>Registration/administration fees (if applicable).</li>
      <li>Payments for downloadable digital content, recorded sessions, or materials already accessed.</li>
    </ul>

    <h4>6. Refund Process</h4>
    <ul>
      <li>Approved refunds will be processed within <strong>7–10 working days</strong>.</li>
      <li>Refunds will be credited to the original payment method (bank account, credit card, or digital wallet).</li>
    </ul>

    <h4>7. Contact Us</h4>
    <p>
      For cancellations or refund requests, please reach out to us via our
      <a routerLink="/contact" (click)="scrollToTop()"
        class="link-offset-2 link-underline link-underline-opacity-0">Contact Us</a> page.
    </p>
  </div>
</section>